import authFetch from './fetch';
import { makeRequest, getQueryParams } from './utils';

const baseUrl = '/api/TruckMake';

const routes = {
  truckMakePath: (id) => `${baseUrl}/${id}`,
  truckMakesPath: (params) => `${baseUrl}${getQueryParams(params)}`,
  truckMakesGridPath: (params) => `${baseUrl}/Grid${getQueryParams(params)}`,
  truckMakesRestorePath: (id) => `${baseUrl}/${id}/restore`,
  truckMakeAuditsPathById: (id, params) => `${baseUrl}/${id}/Audits${getQueryParams(params)}`,
  truckMakeAuditPropertiesPathById: (id) => `${baseUrl}/${id}/Audits/Properties`,
  truckMakeAuditUsersPathById: (id) => `${baseUrl}/${id}/Audits/Users`,

  truckModelPath: (id) => `${baseUrl}/Models/${id}`,
  truckModelsPath: (params) => `${baseUrl}/Models${getQueryParams(params)}`,
  truckModelsLookupPath: (params) => `${baseUrl}/Models/Lookup${getQueryParams(params)}`,
  truckModelsRestorePath: (id) => `${baseUrl}/Models/${id}/restore`,
};

export const getTruckMakesGrid = (params) => makeRequest(authFetch.get(routes.truckMakesGridPath(params)));
export const getTruckMakes = (params) => makeRequest(authFetch.get(routes.truckMakesPath(params)));

export const getTruckMake = (id) => makeRequest(authFetch.get(routes.truckMakePath(id)));

export const putTruckMake = (data) => makeRequest(authFetch.put(routes.truckMakesPath(), data));

export const restoreTruckMake = (id) => makeRequest(authFetch.patch(routes.truckMakesRestorePath(id)));

export const deleteTruckMake = (id) => makeRequest(authFetch.delete(routes.truckMakePath(id)));

export const getTruckMakeAudits = (id, params) =>
  makeRequest(authFetch.get(routes.truckMakeAuditsPathById(id, params)));
export const getTruckMakeAuditProperties = (id) =>
  makeRequest(authFetch.get(routes.truckMakeAuditPropertiesPathById(id)));
export const getTruckMakeAuditUsers = (id) => makeRequest(authFetch.get(routes.truckMakeAuditUsersPathById(id)));

export const getTruckModels = (params) => makeRequest(authFetch.get(routes.truckModelsPath(params)));

export const getTruckModelsLookup = (params) => makeRequest(authFetch.get(routes.truckModelsLookupPath(params)));

export const getTruckModel = (id) => makeRequest(authFetch.get(routes.truckModelPath(id)));

export const postTruckModel = (data) => makeRequest(authFetch.put(routes.truckModelsPath(), data));

export const deleteTruckModel = (id) => makeRequest(authFetch.delete(routes.truckModelPath(id)));

export const restoreTruckModel = (id) => makeRequest(authFetch.patch(routes.truckModelsRestorePath(id)));
